import {RecordInformationBody, UpdateRecordAuditHeaderRequestBody} from '@dms/api/core';
import {RecordIdHttpModel} from '@dms/api/shared';

import {getApiDateString} from 'shared/web';

import {RecordAuditMetadataFormValue} from '../components/recordAuditMetadataFormSchema';
import {toRecordAuditParticipants} from './toRecordAuditParticipants';

export const toUpdateRecordAuditHeaderBody = (args: {
  values: RecordAuditMetadataFormValue;
  pairedRecord: RecordIdHttpModel | null;
  recordInformation: RecordInformationBody | null;
}): UpdateRecordAuditHeaderRequestBody => ({
  auditorEmployeeId: args.values.auditorEmployeeId,
  responsiblePersonEmployeeId: args.values.responsiblePersonEmployeeId,
  branchId: args.values.branchId,
  date: getApiDateString(args.values.date),
  participants: toRecordAuditParticipants(args.values.participants),
  recordId: args.pairedRecord,
  recordInformation: args.recordInformation,
});
